import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons"

export const QuestionCircle = (props) => {
  return <FontAwesomeIcon faIcon={faQuestionCircle} {...props} />
}
